import React from "react";
import { Col, Row } from "@themesberg/react-bootstrap";
import { AddProductComponent } from "../components/AddProductComponent";

export default function AddProduct () {
  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4"></div>
      <Row className="mb-5">
        <Col xs={12} xl={12}>
        <AddProductComponent/>
        </Col>
      </Row>
    </>
  );
};
